<div class="disp" [attr.translate]="'no'">
  <div class="card">
    <div class="card-header">
      <ng-content select="[header]"></ng-content>
    </div>
    <div class="card-body">
      <ng-content></ng-content>
    </div>
  </div>
</div>
